import { ascenderProp, capHeightProp, descenderProp, fontSizeProp, lineHeightProp, xHeightProp } from './custom-properties/font';
export function getFontMetric(set, property, key = 'current') {
    const fontSize = set.var(fontSizeProp[key]);
    const metric = set.var(property[key]);
    return `calc(${fontSize} * ${metric})`;
}
export function getReferenceBaseline(set, value, key) {
    switch(value){
        case 'cap-middle':
            return `calc(${getFontMetric(set, capHeightProp, key)} / 2)`;
        case 'x-middle':
            return `calc(${getFontMetric(set, xHeightProp, key)} / 2)`;
        case 'x-height':
            return getFontMetric(set, xHeightProp, key);
        case 'alphabetic':
        default:
            return '0px';
    }
}
export function getTargetBaseline(set, value) {
    switch(value){
        case 'object-bottom':
            return '0%';
        case 'object-middle':
            return '50%';
        case 'object-top':
            return '100%';
        default:
            return getReferenceBaseline(set, value, 'current');
    }
}
export function getAlphabeticBaseline(set, key) {
    const ascender = getFontMetric(set, ascenderProp, key);
    const descender = getFontMetric(set, descenderProp, key);
    const lineHeight = set.var(lineHeightProp[key]);
    return `calc((${ascender} + ${descender} + ${lineHeight}) / 2)`;
}

//# sourceMappingURL=font-utils.js.map